import { Link } from "react-router-dom";
import sbcLogo from "@/assets/sbc-logo-light-canvas-1200x400.png";

export function AppFooter() {
  return (
    <footer className="mt-24 border-t border-border bg-background">
      <div className="container py-10">
        <div className="flex flex-col gap-6 md:flex-row md:items-start md:justify-between">
          <div className="max-w-md space-y-3">
            <div className="flex items-center gap-2">
              <img
                src={sbcLogo}
                alt="Spiral Beyond Compliance"
                className="h-7 w-auto object-contain"
                data-testid="app-footer-logo"
              />
              <span className="font-display text-sm font-medium">Spiral Beyond Compliance</span>
            </div>
            <p className="text-sm leading-relaxed text-muted-foreground">
              NDIS 0138 Readiness supports SIL providers to work through the new SIL Practice Standards and registration requirements.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 text-sm">
            <div>
              <p className="eyebrow mb-2">Framework</p>
              <ul className="space-y-1.5 text-foreground/80">
                <li>R — Registration Pathway</li>
                <li>E — Evidence Mapping</li>
                <li>A — Assessment of Risk</li>
                <li>D — Danger Escalation</li>
                <li>Y — Your 30 / 60 / 90 Day Plan</li>
              </ul>
            </div>
            <div>
              <p className="eyebrow mb-2">Boundaries</p>
              <ul className="space-y-1.5 text-foreground/80">
                <li>Not legal advice</li>
                <li>Not audit certification</li>
                <li>Not registration approval</li>
                <li>Not a compliance guarantee</li>
                <li>Not an NDIS Commission outcome</li>
              </ul>
            </div>
          </div>
        </div>
        <div
          data-testid="footer-data-privacy"
          className="mt-8 rounded-sm border border-border bg-card/60 p-4 text-sm leading-relaxed text-muted-foreground"
        >
          <p>
            <span className="font-medium text-foreground">Data &amp; privacy:</span>{" "}
            Assessment progress is held in your browser (localStorage) so you can resume later.
            Nothing is sent to a server unless you click Save to Server. Server records are
            de-identified provider snapshots only and are retained until the consultancy manually
            removes them.
          </p>
        </div>
        <div
          data-testid="footer-owner-line"
          className="mt-4 text-xs leading-relaxed text-muted-foreground"
        >
          Operated by{" "}
          <span className="text-foreground">
            JOHN MARTIN KENNEALLY ABN 82 097 590 964 trading as Spiral Beyond Compliance
          </span>
          .{" "}
          <Link
            to="/terms"
            data-testid="footer-owner-terms-link"
            className="underline decoration-border underline-offset-4 hover:text-foreground"
          >
            See Terms of use for consultancy details and contact.
          </Link>
        </div>
        <div className="mt-10 flex flex-col gap-2 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span className="font-mono-label uppercase tracking-[0.18em]">
            Owner-operated consultancy · Optional de-identified server persistence
          </span>
          <span className="flex flex-wrap items-center gap-3">
            <Link
              to="/terms"
              data-testid="footer-terms-link"
              className="underline decoration-border underline-offset-4 hover:text-foreground"
            >
              Terms of use
            </Link>
            <span>© {new Date().getFullYear()} R.E.A.D.Y. Readiness Consultancy</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
